import { mapKeys } from 'lodash';

async function getAdvertisementsMetrics() {
  const responsePromise = await fetch('/advertisementsMetrics.json');

  const response = await responsePromise.json();
  return mapKeys(response, (value, key) => {
    return key.toCamelCase();
  });
}

export default getAdvertisementsMetrics;
